<template>
	<div class="customers-display">
		<div class="customers-row" v-if="currCustomer">
			<div class="customer-data-container">
				<div class="customer-data-edit" v-if="!notEditable && currCustomer?.type !== 'company'">
					<AppButtonIcon prevent-change icon-name="icon-edit-white" @click-icon="editCustomer" />
				</div>
				<div class="customer-data-edit" v-if="currCustomer?.type === 'company'">
					<AppButtonIcon prevent-change color="var(--color-bg-primary-1)" icon-name="icon-points" @click-icon="editCustomerCompany" />
				</div>
				<div class="customers-data">
					<div class="customer-name"><p>{{ currCustomer?.name ? currCustomer?.name : '-' }}</p></div>
					<div class="customer-type">{{ getString(currCustomer?.type) }} <span v-if="counterStore?.invoiceAdditionalData?.purchase_order"> - {{getString('purchase_order_x', [counterStore?.invoiceAdditionalData?.purchase_order])}}</span></div>
				</div>
			</div>
			<div class="customer-icon" v-html="svgStore.get('iconBin')" v-if="!notEditable" @click="removeCustomer"></div>
		</div>
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="activeEditInvoiceInfo" @toggling-popup="togglingPopupInvoiceInfo">
			<div class="wrapper-buttons-add mb-10">
				<ModalHeader
					:title="getString('invoice_x', [this.currCustomer ? this.currCustomer?.name : '-'])"
				/>
				<AppList :items="editInvoiceInfoList" />
			</div>
		</AppBottomSheet>
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="activeEditInvoiceData" @toggling-popup="togglingPopupInvoiceData">
			<div class="wrapper-buttons-add mb-10" v-if="activeEditInvoiceData">
				<ModalHeader
					:title="getString('edit_invoice_x', [this.currCustomer ? this.currCustomer?.name : '-'])"
					:button-text="getString('confirm')"
					@clickButton="updateInvoiceData"
				/>
				<InvoiceDataEditor ref="invoice-data-editor" :starting-purchase-order="invoicePurchaseOrder" />
			</div>
		</AppBottomSheet>
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="!!personId" @toggling-popup="togglingPopupPersonDetails">
			<div class="customers-display" v-if="personId">
				<ModalHeader
					:button-text="getString('save')"
					@clickButton="updateCustomer"
					:title="getString('edit_x', [this.currCustomer ? this.currCustomer?.name : '-'])" />
				<CustomersPersonEditDetails @deleted-customer="emitDeletedPersonCustomer" ref="person-details" :person-id="personId" />
			</div>
		</AppBottomSheet>
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="!!companyId" @toggling-popup="togglingPopupCompanyDetails">
			<div class="customers-display" v-if="companyId">
				<ModalHeader
					:button-text="getString('save')"
					@clickButton="updateCustomer"
					:title="getString('edit_x', [this.currCustomer ? this.currCustomer?.name : '-'])"
				/>
				<CustomersCompanyEditDetails @deleted-company="emitDeletedCompanyCustomer" @updated-company="togglingPopupCompanyDetails(false)" ref="company-details" :company-id="companyId" />
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>
import AppButton from "@/shared/components/AppButton.vue";
import AppList from "@/shared/components/AppList.vue";
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import {useCounterStore, useCustomersStore} from "@/console-new/stores";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import CustomersCompanyAdd from "@/console-new/components/ops/CustomersCompanyAdd.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import CustomersPersonEditDetails from "@/console-new/components/ops/CustomersPersonEditDetails.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import CustomersCompanyEditDetails from "@/console-new/components/ops/CustomersCompanyEditDetails.vue";
import InvoiceDataEditor from "@/console-new/components/ops/InvoiceDataEditor.vue";
import AppLoader from "@/shared/components/AppLoader.vue";

export default {
	setup() {
		const counterStore = useCounterStore();
		const customersStore = useCustomersStore();
		const svgStore = useSvgStore();
		const languageStore = useLanguageStore();
		return {counterStore, svgStore, getString: languageStore.getString, customersStore};
	},
	name: "CustomersDisplay",
	mixins: [WindowWidth],
	emits: ['deleted-customer', 'deleted-company'],
	components: {AppLoader, ModalHeader, AppBottomSheet, InvoiceDataEditor, CustomersCompanyAdd, AppList, AppButtonIcon, AppButton, CustomersPersonEditDetails, CustomersCompanyEditDetails},
	data() {
		return {
			personId: null,
			companyId: null,
			activeEditInvoiceInfo: false,
			activeEditInvoiceData: false,
		}
	},
	computed: {
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		currCustomer() {
			if(this.isRegistry) {
				return this.counterStore?.registryEditingCustomer;
			}
			return this.counterStore?.selectedCustomer;
		},
		editInvoiceInfoList() {
			let list = [];
			if(!this.notEditable) {
				list.push({title: this.getString('edit_x', [this.getString('company')]), buttonTitle: this.getString('edit'), callbackButton: this.editCustomer});
			}
			list.push({title: this.getString('edit_x', [this.getString('invoice')]), buttonTitle: this.getString('edit'), callbackButton: this.editInvoiceData});
			return list;
		},
		invoicePurchaseOrder() {
			return this.counterStore.invoiceAdditionalData?.purchase_order || null;
		},
	},
	methods: {
		removeCustomer() {
			this.counterStore.selectedCustomer = null;
		},
		editInvoiceData() {
			this.activeEditInvoiceData = true;
		},
		editCustomerCompany() {
			this.activeEditInvoiceInfo = true;
		},
		editCustomer() {
			if(this.counterStore.selectedCustomer) {
				if(this.currCustomer?.type === "person") {
					this.customersStore.customersPeople = [this.counterStore.selectedCustomer];
					this.personId = this.currCustomer?.customer_id;
				} else if(this.currCustomer?.type === "company") {
					this.customersStore.customersCompanies = [this.counterStore.selectedCustomer];
					this.companyId = this.currCustomer?.customer_id;
				}
			}
		},
		updateInvoiceData() {
			if(this.currCustomer?.type === "company") {
				let invoiceDataEditor = this.$refs["invoice-data-editor"];
				if(invoiceDataEditor && invoiceDataEditor?.toUpdate) {
					let additionalInvoiceData = invoiceDataEditor.getData();
					if(additionalInvoiceData) {
						this.counterStore.invoiceAdditionalData.purchase_order = additionalInvoiceData.purchase_order;
					}
				}
			}
			this.activeEditInvoiceData = false;
		},
		updateCustomer() {
			if(this.currCustomer?.type === "person") {
				this.$refs["person-details"] && this.$refs["person-details"].updatePerson();
			} else if(this.currCustomer?.type === "company") {
				this.$refs["company-details"] && this.$refs["company-details"].updateCompany();
			}
		},
		togglingPopupPersonDetails(isOpen) {
			if(!isOpen) {
				this.personId = null;
			}
		},
		togglingPopupInvoiceInfo(isOpen) {
			if(!isOpen) {
				this.activeEditInvoiceInfo = false;
			}
		},
		togglingPopupInvoiceData(isOpen) {
			if(!isOpen) {
				this.activeEditInvoiceData = false;
			}
		},
		togglingPopupCompanyDetails(isOpen) {
			if(!isOpen) {
				this.companyId = null;
			}
		},
		emitDeletedPersonCustomer(personId) {
			this.$emit('deleted-customer', personId);
			this.personId = null;
		},
		emitDeletedCompanyCustomer(companyId) {
			this.$emit('deleted-company', companyId);
			this.companyId = null;
		},
	},
	props: {
		notEditable: {
			type: Boolean,
			default: false,
		},
		isRegistry: {
			type: Boolean,
			default: false,
		},
		isOrders: {
			type: Boolean,
			default: false,
		},
	}
}
</script>

<style scoped lang="scss">
.customers-display {
	width: 100%;

	.customers-row {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding: 6px 10px;
		border: 1px solid var(--color-alpha-2);
		border-radius: 13px;
		width: 100%;
		margin-top: 10px;
		margin-bottom: 10px;

		.customer-data-container {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;
			max-width: calc(100% - 40px);
			width: 100%;

			.customer-data-edit {
				display: flex;
				justify-content: center;
				align-items: center;
				user-select: none;
				cursor: pointer;
				margin-right: 8px;
			}

			.customers-data {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: flex-start;
				max-width: calc(100% - 20px);

				.customer-name {
					display: block;
					max-width: 100%;
					p {
						max-width: 100%;
						font-size: 16px;
						font-weight: 500;
						@include truncateString(1);
					}
				}

				.customer-type span {
					font-size: 12px;
					color: $txt_2;
				}

				.customer-type {
					font-size: 12px;
					color: $txt_2;

					span {
						line-height: inherit;
					}
				}

			}

		}


		.customer-icon {
			width: 24px;
			height: 24px;
			display: flex;
			justify-content: center;
			align-items: center;
			user-select: none;
			cursor: pointer;
			padding: 4px;

			:deep(svg) {
				width: 100%;
				height: 100%;
				.fill {
					fill: var(--color-svg-primary);
				}
				.stroke {
					stroke: var(--color-svg-primary);
				}
			}
		}
	}
}
.wrapper-buttons-add {
	height: 100%;
	width: 100%;
	.row-button-add {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}
	.base-button {
		height: 40px;
		width: calc(50% - 5px);
		background-color: var(--color-fill-button);
		border: none;
		&:hover {
			box-shadow: none;
			background-color: var(--color-fill-button-hover);
		}
	}
}
</style>